import Vue from 'vue'
import store from '../store/store'
import VueCookie from 'vue-cookie'

export default {
    check() {
        if (VueCookie.get('jwt')) {
            store.dispatch('setJWT', VueCookie.get('jwt'));
        }
        return store.getters.jwt;
    }
}